import { Component } from 'react';
import { AppSettings } from './common/AppSettings';

export class Auth extends Component {
  static displayName = Auth.name;

  render() {
    return null;
  }

  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);
    const shopOrigin = urlParams.get('shop');
    const apiKey = AppSettings.ShopifyApiKey;
    const redirectUri = AppSettings.AuthRedirect;
    const permissionUrl = `https://${shopOrigin}/admin/oauth/authorize?client_id=${apiKey}&scope=read_products,write_products&access_mode=offline&redirect_uri=${redirectUri}&nonce=4257d4b5-d65d-43fa-8c16-56df3c53e60b`;

    window.location.assign(permissionUrl);
  }
}